export function calculateWeightedOverallScore(scoresObj, weightsConfig) {
  const expectedKeys = Object.keys(scoresObj);
  if (expectedKeys.length === 0) return null;

  // If ALL expected scores are effectively empty/null, return null.
  // This ensures candidates who haven't started at all show "—" instead of "0%".
  const hasAnyValidScore = expectedKeys.some(k => scoresObj[k] != null && scoresObj[k] !== '');
  if (!hasAnyValidScore) return null;

  // Parse scores safely: null, undefined, or empty string becomes 0
  const parseScore = (val) => {
    if (val == null || val === '') return 0;
    const num = parseFloat(val);
    return isNaN(num) ? 0 : num;
  };

  const scores = {};
  expectedKeys.forEach((k) => {
    scores[k] = parseScore(scoresObj[k]);
  });

  if (expectedKeys.length === 1) return scores[expectedKeys[0]];

  if (weightsConfig) {
    let weights = null;
    if (
      expectedKeys.length === 3 &&
      expectedKeys.includes('resume') &&
      expectedKeys.includes('assessment') &&
      expectedKeys.includes('interview')
    ) {
      weights = weightsConfig.all_three;
    } else if (expectedKeys.length === 2) {
      if (expectedKeys.includes('resume') && expectedKeys.includes('assessment')) {
        weights = weightsConfig.res_assess;
      } else if (expectedKeys.includes('resume') && expectedKeys.includes('interview')) {
        weights = weightsConfig.res_interview;
      } else if (expectedKeys.includes('assessment') && expectedKeys.includes('interview')) {
        weights = weightsConfig.assess_interview;
      }
    }

    if (weights) {
      const validWeights = expectedKeys.map((k) => {
        const w = parseFloat(weights[k]);
        return isNaN(w) ? null : w;
      });
      if (validWeights.every((w) => w != null)) {
        let totalWeight = 0;
        let totalScore = 0;
        expectedKeys.forEach((k) => {
          const w = parseFloat(weights[k]);
          totalWeight += w;
          totalScore += scores[k] * w;
        });
        if (totalWeight > 0) {
          return Math.round(totalScore / totalWeight);
        }
      }
    }
  }

  // Fallback to strict average over the number of expected modules
  const total = expectedKeys.reduce((sum, k) => sum + scores[k], 0);
  return Math.round(total / expectedKeys.length);
}
